import React from 'react';
import { withRouter } from 'react-router-dom';
import Grid from './Grid.jsx';

class Centros extends React.Component {

    constructor() {

        super();

        this.state = {
            gridHeader: [
                "Nome",
                "Banco",
                "Agência",
                "Conta Bancária",
                "Saldo Inicial",
                "Saldo Atual",
                "Saldo Inicial de Investimento",
                "Saldo de Investimento",
                "Banco (2)",
                "Agência (2)",
                "Conta Bancária (2)",
                "Saldo Inicial (2)",
                "Saldo Atual (2)",
                "Saldo Inicial de Investimento (2)",
                "Saldo de Investimento (2)",
                "Status" ],
            centros: [],
        }

        this.cadastrarCentro = this.cadastrarCentro.bind(this);

    }

    cadastrarCentro() {
        this.props.history.push("/cadastrarcentro");
    }

    componentDidMount() {

        if (localStorage.roleCentros === "nenhuma") {
            window.location.href = "/home";
        }

        fetch("/api/centro/grid", {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centros: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="centros-titulo">Centros de Custo</h1><br />
                <p id="centros-txt">
                    Clique em um dos centros para visualizar suas informações.
                </p><br />
                <Grid key={ this.state.centros }
                    header={ this.state.gridHeader }
                    data={ this.state.centros }
                    pageSize={ 10 }
                    gridWidth={ "1150px" }
                    linkTo={ "/visualizarcentro" } />
                { localStorage.roleCentros === "escrever" &&
                    <button type="button" id="centros-cadastrar-btn" onClick={ this.cadastrarCentro }>
                        Cadastrar Centro
                    </button> }
            </div>
        );
    }

}

export default withRouter(Centros);

